export default __webpack_public_path__ + "static/media/template4.3498f1c8.jpg";